/* This is the EMIS student primary school components with 2 tabs for each table */
<template>
  <v-container>
    <!-- ======================Block table 1======================= -->
    <div>
      <span v-html="title + ' ' + curacc"></span>
    </div>
    <div>
      <table
        style="height: 87px; width: 980px"
        border="1px;"
        cellspacing="0px;"
      >
        <tbody>
          <tr>
            <td class="col-title" rowspan="3">
              អាយុ
              <p>(ឆ្នាំ)</p>
            </td>
            <td class="row-header-title" colspan="4">ថ្នាក់ទី ១</td>
            <td class="row-header-title" colspan="4">ថ្នាក់ទី ២</td>
            <td class="row-header-title" colspan="4">ថ្នាក់ទី ៣</td>
            <td class="row-header-title" colspan="4">ថ្នាក់ទី ៤</td>
          </tr>
          <tr>
            <td class="row-header" colspan="2">សិស្សថ្មី</td>
            <td class="row-header" colspan="2">សិស្សត្រួតថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សឡើងថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សត្រួតថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សឡើងថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សត្រួតថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សឡើងថ្នាក់</td>
            <td class="row-header" colspan="2">សិស្សត្រួតថ្នាក់</td>
          </tr>
          <tr>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
          </tr>
          <!-- Data row -->
          <tr
            v-for="(value, row) in age.length"
            v-if="row >= age_cont"
            :key="row"
          >
            <!-- Draw only 16 columns -->
            <td class="col-title">{{ age[row] }}</td>
            <td
              v-for="(value, col) in 16"
              :key="col"
              :class="[!onOff1[row][col] ? 'row-data-gray' : 'row-data']"
            >
              <numberinput
                v-model="data[row].dt[col]"
                :disabled="!onOff1[row][col]"
                class="number"
              />
            </td>
          </tr>
          <!-- Total each column -->
          <tr>
            <td class="col-title">សរុប</td>
            <td v-for="(value, col) in 16" :key="col" class="row-data">
              <strong>{{ totalRow[col] | blank }}</strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- ======================Block table 2======================= -->
    <p></p>
    <div>
      <span v-html="title + ' ' + curacc + ' (បន្ត)'"></span>
    </div>
    <div>
      <table style="height: 87px; width: 850px" border="1px" cellspacing="0px;">
        <tbody>
          <tr>
            <td class="col-title" rowspan="3">
              អាយុ
              <p>(ឆ្នាំ)</p>
            </td>
            <td class="row-header-title2" colspan="4">ថ្នាក់ទី ៥</td>
            <td class="row-header-title2" colspan="4">ថ្នាក់ទី ៦</td>
            <td class="row-header-title2" colspan="4">
              សរុបរួម (ពីថ្នាក់ទី ១ ដល់ទី ៦)
            </td>
          </tr>
          <tr>
            <td class="row-header2" colspan="2">សិស្សថ្មី</td>
            <td class="row-header2" colspan="2">សិស្សត្រួតថ្នាក់</td>
            <td class="row-header2" colspan="2">សិស្សឡើងថ្នាក់</td>
            <td class="row-header2" colspan="2">សិស្សត្រួតថ្នាក់</td>
            <td class="row-header2" colspan="2">សិស្សថ្មី / សិស្សឡើងថ្នាក់</td>
            <td class="row-header2" colspan="2">សិស្សត្រួតថ្នាក់</td>
          </tr>
          <tr>
            <td class="row-data2">សរុប</td>
            <td class="row-data2">ស្រី</td>
            <td class="row-data2">សរុប</td>
            <td class="row-data2">ស្រី</td>
            <td class="row-data2">សរុប</td>
            <td class="row-data2">ស្រី</td>
            <td class="row-data2">សរុប</td>
            <td class="row-data2">ស្រី</td>
            <td class="row-data2">សរុប</td>
            <td class="row-data2">ស្រី</td>
            <td class="row-data2">សរុប</td>
            <td class="row-data2">ស្រី</td>
          </tr>
          <tr
            v-for="(value, row) in age.length"
            v-if="row >= age_cont"
            :key="row"
          >
            <td class="col-title">{{ age[row] }}</td>
            <!-- draw the last 8 columns in the array -->
            <td
              v-for="(value, col) in 8"
              :key="col"
              :class="[!onOff2[row][col] ? 'row-data-gray2' : 'row-data2']"
            >
              <numberinput
                v-model="data[row].dt[col + 16]"
                :disabled="!onOff2[row][col]"
                class="number2"
              />
            </td>
            <!-- total in each row -->
            <td class="row-data2">
              <strong>{{ col1[row] }}</strong>
            </td>
            <td class="row-data2">
              <strong>{{ col2[row] }}</strong>
            </td>
            <td class="row-data2">
              <strong>{{ col3[row] }}</strong>
            </td>
            <td class="row-data2">
              <strong>{{ col4[row] }}</strong>
            </td>
          </tr>
          <!-- Total each column -->
          <tr>
            <td class="col-title">សរុប</td>
            <td v-for="(value, col) in 8" :key="col" class="row-data2">
              <strong>{{ totalRow[col + 16] | blank }}</strong>
            </td>
            <!-- Total each row and column -->
            <td class="row-data2">
              <strong>{{ tCol1 | blank }}</strong>
            </td>
            <td class="row-data2">
              <strong>{{ tCol2 | blank }}</strong>
            </td>
            <td class="row-data2">
              <strong>{{ tCol3 | blank }}</strong>
            </td>
            <td class="row-data2">
              <strong>{{ tCol4 | blank }}</strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import NumberInput from "@/components/common/NumberInput.vue";
import { priAge, stupriOnOff1, stupriOnOff2 } from "@/utils/ascf/priConfig.js";
export default {
  props: ["data", "age_cont", "curacc", "title"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      age: priAge,
      onOff1: stupriOnOff1,
      onOff2: stupriOnOff2,
    };
  },
  // Compute function for re-entry program
  computed: {
    /* col1, col2, col3 and col4 are computed function in each row by age and total/gender */
    col1: function () {
      let result;
      let d = this.data;
      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (i % 4 === 0) {
            r[ind] = (r[ind] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      return result;
    },
    col2: function () {
      let result;
      let d = this.data;
      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (i % 4 === 1) {
            r[ind] = (r[ind] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      return result;
    },
    col3: function () {
      let result;
      let d = this.data;
      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (i % 4 === 2) {
            r[ind] = (r[ind] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      return result;
    },
    col4: function () {
      let result;
      let d = this.data;
      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (i % 4 === 3) {
            r[ind] = (r[ind] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      return result;
    },
    /* totalRow are the summing of each column total and female */
    totalRow: function () {
      let result;
      let d = this.data;
      let ldata = this.data.length - 1;

      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (ind < ldata) {
            // do summing 0 to last - 1 only (last is sum array)
            r[i] = (r[i] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      // update the total row array in JSON
      d[ldata].dt.forEach(function (b, i) {
        d[ldata].dt[i] = result[i];
      });
      return result;
    },
    /* tCol1, tCol2, tcol3 and tcol4 are the total of total row and column */
    tCol1: function () {
      let d = this.totalRow;
      return d[0] + d[4] + d[8] + d[12] + d[16] + d[20];
    },
    tCol2: function () {
      let d = this.totalRow;
      return d[1] + d[5] + d[9] + d[13] + d[17] + d[21];
    },
    tCol3: function () {
      let d = this.totalRow;
      return d[2] + d[6] + d[10] + d[14] + d[18] + d[22];
    },
    tCol4: function () {
      let d = this.totalRow;
      return d[3] + d[7] + d[11] + d[15] + d[19] + d[23];
    },
  },
  filters: {
    blank: function (value) {
      if (value == 0) return "";
      return value;
    },
  },
};
</script>

<style scoped>
.number {
  width: 55px;
  text-align: center;
}
.row-data {
  width: 55px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.row-data-gray {
  width: 55px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
  background-color: lightgray;
}
.row-header {
  width: 110px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.row-header-title {
  width: 220px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.number2 {
  width: 60px;
  text-align: center;
}
.row-data2 {
  width: 60px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.row-data-gray2 {
  width: 60px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
  background-color: lightgray;
}
.row-header2 {
  width: 120px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.row-header-title2 {
  width: 240px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.col-title {
  width: 80px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
</style>